import type { FC } from 'react';

import { SecondaryText } from './styles';

interface DosageAndQuantitySectionProps {
  dosage: string;
  quantity: string;
}

export const DosageAndQuantitySection: FC<DosageAndQuantitySectionProps> = ({ dosage, quantity }) => {
  if (dosage && quantity) {
    return (
      <SecondaryText>
        {dosage} / {quantity}
      </SecondaryText>
    );
  } else if (dosage) {
    return <SecondaryText>{dosage}</SecondaryText>;
  } else if (quantity) {
    return <SecondaryText>{quantity}</SecondaryText>;
  }
  return null;
};
